import React, { useEffect } from 'react';

export const Dialog = (props) => {
  const handleConfirm = () => props.onDialogConfirm();
  const handleCancel = () => props.onDialogCancel();

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return (() => document.body.style.overflow = null);
  });

  return (
    <div className="myaimopark-confirm" data-selection-no="true">
      <section className="myaimopark-confirm__box" role="alert">
        {props.shouldIncludeCloseButton && 
          <header>
            <button data-selection-no="true">Close</button>
          </header>
        }
        <main>
          <h1>{props.langHeading ?? props.lang.heading}</h1>
          {props.children}
          {props.onDialogCancel &&
            <button onClick={() => handleCancel()} data-selection-no="true" className="myaimopark-confirm__box__cancel">{props.langCancel ?? props.lang.cancel}</button>
          }
          {props.onDialogConfirm &&
            <button onClick={() => handleConfirm()} data-selection-yes="true" className="myaimopark-confirm__box__confirm">{props.langConfirm ?? props.lang.confirm}</button>
          }
        </main>
      </section>    
    </div>
  );
}